export default "__VITE_ASSET__e26d100a__"